/**
 * Customer portal magic-link token helpers.
 */

const DEFAULT_PORTAL_BASE_URL = 'https://portal.87c.us';

/** URL-safe random token (48 hex chars = 24 bytes). */
export function generatePortalToken() {
  const bytes = new Uint8Array(24);
  crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
}

export function buildPortalUrl(baseUrl, token) {
  if (!baseUrl || !token) return '';
  return `${String(baseUrl).replace(/\/$/, '')}/c/${token}`;
}

export function getDefaultPortalBaseUrl() {
  return DEFAULT_PORTAL_BASE_URL;
}
